import { useTranslation } from 'react-i18next'

import { getManagerProfileOptions } from '../../../api'
import { getItemsFromIdwellApiResponse } from '../../../utils/api'
import {
  getResponsibleManagersExceededNotification,
  getResponsibleManagersFieldErrorProps,
} from '../../Form'
import { toUserSelectItemsFromOption } from '../../User'
import { RequestEditUserModal } from '../RequestEditUserModal'

import {
  REQUEST_EDIT_MANAGER_FIELD_NAME_ASSIGNEES,
  REQUEST_EDIT_MANAGER_FORM_BODY_PROPS,
  REQUEST_EDIT_MANAGER_MODAL_QA_NAME,
} from './RequestEditManagerModal.constants'
import {
  getRequestEditManagerModalPayload,
  getRequestEditManagerModalValidationSchema,
} from './RequestEditManagerModal.utils'

function RequestEditManagerModal({ formFieldsProps, onSubmit, ...restProps }) {
  const { t } = useTranslation()

  function handleSubmit({ values }) {
    onSubmit({ payload: getRequestEditManagerModalPayload(values), values })
  }

  return (
    <RequestEditUserModal
      {...restProps}
      containerProps={{
        qaName: REQUEST_EDIT_MANAGER_MODAL_QA_NAME,
      }}
      formBodyProps={REQUEST_EDIT_MANAGER_FORM_BODY_PROPS}
      formFieldsProps={{
        ...formFieldsProps,
        userFieldProps: {
          controlProps: {
            contentProps: {
              inputProps: {
                placeholder: t('Request.AssigneeTextPlaceholderKey'),
              },
            },
          },
          fieldComponentProps: {
            label: `${t('Request.AssigneeLabelKey')}`,
          },
          getData: getManagerProfileOptions,
          getDataItems: getItemsFromIdwellApiResponse,
          getErrorProps: getResponsibleManagersFieldErrorProps,
          label: t('Request.AssigneeLabelKey'),
          toPreparedItems: toUserSelectItemsFromOption,
        },
        withTypeSelectError: false,
      }}
      formTitle='Modal.EditAssigneeTitleKey'
      getValidationSchema={getRequestEditManagerModalValidationSchema}
      initialNotifications={[getResponsibleManagersExceededNotification(t)]}
      userFieldName={REQUEST_EDIT_MANAGER_FIELD_NAME_ASSIGNEES}
      onSubmit={handleSubmit}
    />
  )
}

export default RequestEditManagerModal
